// extracted by mini-css-extract-plugin
export default {"sales":"partnerSales_sales__tfo3R"};